<template>
  <v-layout>
    <v-app-bar color="primary" density="compact">
      <template v-slot:prepend>
        <v-img :width="30" aspect-ratio="1/1" cover src="/assets/images/logo.png"></v-img>
      </template>

      <v-app-bar-title>Prismap</v-app-bar-title>

      <template v-slot:append>
        <div v-if="!$vuetify.display.mobile">
          <v-btn v-if="!auth" @click="goTo('home')">Inicio</v-btn>
          <v-btn color="secondary" variant="flat" v-if="!auth" @click="goTo('access')">Iniciar Sesión</v-btn>
          <v-btn variant="text" v-if="auth" @click="goTo('institution')">Institución</v-btn>
          <v-btn variant="text" v-if="auth" @click="goTo('documents')">Data</v-btn>
          <v-btn variant="text" v-if="auth" @click="goTo('reports')">Reportes</v-btn>
          <v-btn icon="mdi-exit-to-app" v-if="auth" @click="goToOut()"></v-btn>
        </div>
        <div v-if="$vuetify.display.mobile">
          <v-icon-btn class="mr-3" :active="drawer" active-color="surface-variant" icon="mdi-menu">
            <v-icon>mdi-menu</v-icon>
            <v-menu v-model="drawer" activator="parent" location="bottom end" offset="4">
              <v-list bg-color="surface-light" class="d-flex flex-column ga-1 pa-1" density="compact" rounded="lg"
                variant="text" slim>
                <v-list-item prepend-icon="mdi-home" rounded="lg" title="Inicio" link v-if="!auth" @click="goTo('home')"></v-list-item>
                <v-list-item prepend-icon="mdi-security" rounded="lg" title="Iniciar sesion" link v-if="!auth" @click="goTo('access')"></v-list-item>
                
                <v-list-item prepend-icon="mdi-home" rounded="lg" title="Mi Institución" link v-if="auth" @click="goTo('institution')"></v-list-item>
                <v-list-item prepend-icon="mdi-file" rounded="lg" title="Data" link v-if="auth" @click="goTo('documents')"></v-list-item>
                <v-list-item prepend-icon="mdi-file" rounded="lg" title="Reportes" link v-if="auth" @click="goTo('reports')"></v-list-item>
                <v-list-item prepend-icon="mdi-logout-variant" rounded="lg" title="Cerrar sesión" link v-if="auth" @click="goToOut()"></v-list-item>
              </v-list>
            </v-menu>
          </v-icon-btn>
        </div>
      </template>
    </v-app-bar>

    <v-main style="min-height: 100%;">
      <v-container class="h-100">
        <RouterView @update-auth="updateAuth" />
      </v-container>
    </v-main>
  </v-layout>
  <v-footer id="footer" class="text-center d-flex flex-column ga-2 py-4" color="secondary">
    Prismap 2026
  </v-footer>
</template>
<script setup>
import axios from '@/plugin/axios';
import { useTheme } from 'vuetify'

import { RouterView, useRouter } from 'vue-router';
import { onMounted, onBeforeUnmount, ref, watch } from 'vue';

const router = useRouter();
const drawer = ref(false);
const group = ref(null);
const auth = ref(false);

const theme = useTheme()
let mediaQuery

const updateTheme = (e) => {
  theme.global.name.value = e.matches ? 'dark' : 'light'
}

const updateAuth = (v) => {
  auth.value = v;
}

const goTo = (page) => {
  router.push({name: page});
}

const goToOut = () => {
  sessionStorage.removeItem('auth');
  sessionStorage.removeItem('token');
  auth.value = false;
  router.push('/');
}

watch(group, () => {
  drawer.value = false
})

onMounted(async () => {
  if (sessionStorage.getItem('auth', false)) {
    await axios.get('/token/validate', {
      headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') }
    }).then( () => {
      auth.value = sessionStorage.getItem('auth', false);
    })
    .catch(() => {
      goToOut();
    });   
  } else {
    router.push('/');
  }

  mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  theme.global.name.value = mediaQuery.matches ? 'dark' : 'light'
  mediaQuery.addEventListener('change', updateTheme)
});

onBeforeUnmount(() => {
  mediaQuery.removeEventListener('change', updateTheme)
})

</script>

<style lang="css">
  #footer{
    position: fixed;
    bottom: 0px;
    width: 100vw;
  }
</style>